export default "__VITE_PUBLIC_ASSET__12e8ed29__"